import { LoadingButton } from '@mui/lab';
import { Box } from '@mui/material';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { GeneralSelectMenu } from 'src/components/general';
import { FormProvider, RHFTextField } from 'src/components/hook-form';

const statusList = [
  { title: 'همه', id: '-1' },
  { title: 'فعال', id: '1' },
  { title: 'مصرف شده', id: '2' },
  { title: 'منقضی شده', id: '3' },
];

export default function GiftCodeListTableToolbar({ onChangePage, filterItems, setFilterItems }) {
  const { projectId } = useParams();

  const [selectedStatus, setSelectedStatus] = useState(-1);

  const defaultValues = {
    ...filterItems,
  };

  const methods = useForm({
    defaultValues,
  });

  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = async (values) => {
    const PAYLOAD = {
      ...values,
      AppID: +projectId,
      SubscribePackageID: filterItems?.SubscribePackageID,
      Status: +selectedStatus,
    };

    setFilterItems(PAYLOAD);
    onChangePage(null, 0);
  };

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Box
        sx={{
          display: 'grid',
          columnGap: 2,
          rowGap: 3,
          gridTemplateColumns: { xs: 'repeat(1, 1fr)', sm: 'repeat(2, 1fr)', lg: 'repeat(4, 1fr)' },
          mb: 1,
          gridAutoRows: '56px',
        }}
      >
        <RHFTextField name="Label" type="text" label="عنوان کد" />

        <RHFTextField name="Code" type="text" label="کد" />

        <GeneralSelectMenu label="وضعیت" name="Status" options={statusList} value={selectedStatus} onChangeValue={setSelectedStatus} />

        <LoadingButton size="medium" type="submit" variant="contained" loading={isSubmitting} sx={{ height: '55px', width: '100%' }}>
          جستجو
        </LoadingButton>
      </Box>
    </FormProvider>
  );
}
